import { MenuItem, Typography } from '@mui/material';
import { isNotEmptyString, isNotNullOrUndefined } from '@weft/utils';
import React from 'react';
import { StyledTextField } from '../StyledTextField';

type BaseSelectProps = Omit<React.ComponentProps<typeof StyledTextField>, 'options'> & {
  textFieldProps?: React.ComponentProps<typeof StyledTextField>['inputProps'];
  values: string[] | number[];
  prefix?: string;
  suffix?: string;
  suffixByFieldValue?: Record<string, string>;
};

export const BaseSelect = React.forwardRef<HTMLInputElement, BaseSelectProps>(({ values, label, prefix, suffix, suffixByFieldValue, ...props }, ref) => {
  return (
    <>
      <Typography
        variant='h3'
        className='text-label mb-2 text-sm'
      >
        {label}
      </Typography>
      <StyledTextField
        {...props}
        defaultValue={props.defaultValue || ''}
        variant='standard'
        InputProps={{
          disableUnderline: true,
        }}
        SelectProps={{
          SelectDisplayProps: {
            className: `${props.focused ? 'py-3 pl-6' : 'pb-[0]'} duration-200 linear`,
          },
          IconComponent: props.focused ? undefined : () => null,
          MenuProps: {
            MenuListProps: {
              className: 'p-0',
            },
          },
        }}
        InputLabelProps={{
          shrink: true,
        }}
        ref={ref}
        select
      >
        <MenuItem
          value=""
          placeholder="None"
        >
          <em>None</em>
        </MenuItem>

        {values.map((Base) => (
          <MenuItem
            key={crypto.randomUUID()}
            value={Base}
          >
            <p className="flex gap-x-1">
              {isNotEmptyString(prefix) && <p>{prefix}</p>}
              <p>{Base}</p>
              {isNotEmptyString(suffix) && <p>{suffix}</p>}
              {isNotNullOrUndefined(suffixByFieldValue) && isNotEmptyString(suffixByFieldValue[Base]) && <p>{suffixByFieldValue[Base]}</p>}
            </p>
          </MenuItem>
        ))}
      </StyledTextField>
    </>
  );
});